import React from "react";
import Hero from "../components/Hero";
import TransitionCircle from "../components/TransitionCircle";
import WhyChooseUs from "../components/WhyChooseUs";
import PromotionalBanner from "../components/PromotionalBanner";
import ProductSpecialty from "../components/ProductSpecialty";
import WhatWeDo from "../components/WhatWeDo";
import CategoriesSection from "../components/CategoriesSection";
import TestimonialsSection from "../components/TestimonialsSection";
import BrandPartners from "../components/BrandPartners";

export default function Home() {
  return (
    <div>
      <div className="bg-[#e8e9eb] relative">
        <Hero />
                {/*<BrandPartners />*/}

        <TransitionCircle />
        
      </div>
      {/* The container below provides the background for all subsequent sections, ensuring a seamless transition */}
      <div className="bg-[#e8e9eb] relative">
              <WhatWeDo />
      </div>
              <WhyChooseUs />

              <TestimonialsSection />

      <CategoriesSection />

      <ProductSpecialty />
      <div className="bg-[#e8e9eb] relative">
        <PromotionalBanner />
      </div>
    </div>
  );
}